<template>
  <div class="content-wrap" ref="contentScrollRef">
    <!-- Tab切换 -->
    <div class="tab-list">
      <div 
        v-for="item in menuList" 
        :key="item.key"
        class="tab-item"
        :class="{active: activeKey === item.key}"
        @click="handleMenuItemClick(item.key)"
      >
        {{ item.title }}
      </div>
    </div>

    <!-- 文书主体内容 -->
    <div class="doc-card">
      <h1 class="doc-title">{{ docData.caseNumber || docData.title || '案例详情' }}</h1>
      <div class="doc-sub">{{ docData.subInfo }}</div>
      
      <!-- 参与人 -->
      <div class="section" id="info-person">
        <h3>诉讼参与人</h3>
        <p>{{ docData.participants || '暂无数据' }}</p>
      </div>

      <!-- 审理信息 -->
      <div class="section" id="process">
        <h3>审理经过</h3>
        <p>{{ docData.trialInfo || '暂无数据' }}</p>
      </div>

     

      <!-- 对应目录锚点区块（一审/二审动态字段） -->
      <div 
        v-for="section in docData.sections" 
        :key="section.id"
        :id="section.id" 
        class="section"
      >
        <h3>{{ section.title }}</h3>
        <p>{{ section.text || '暂无数据' }}</p>
      </div>
       <!-- 审判组织 -->
      <!-- <div class="section" id="trial-org">
        <h3>审判组织</h3>
        <p>{{ docData.trialOrg || '暂无数据' }}</p>
      </div> -->
    </div>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  activeTab: String,
  analyzeData: Object,
  menuList: {
    type: Array,
    default: () => []
  },
  activeKey: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['tab-change', 'scroll-to', 'menu-change'])

const contentScrollRef = ref(null)

// 【修复】基于自身滚动容器精准滚动，不再全局滚动
const scrollToSection = (id) => {
  const scrollBox = contentScrollRef.value
  if (!scrollBox) return

  const targetDom = document.getElementById(id)
  if (!targetDom) return

  // 获取目标元素相对滚动容器的顶部距离
  const targetTop = targetDom.offsetTop - scrollBox.offsetTop
  scrollBox.scrollTo({
    top: targetTop,
    behavior: 'smooth'
  })
}

defineExpose({ scrollToSection, contentScrollRef })

const handleMenuItemClick = (key) => {
  emit('menu-change', key)
}
const docData = ref({
  caseNumber: '',
  title: '',
  subInfo: '',
  participants: '',
  trialInfo: '',
  trialOrg: '',
  sections: []
})

// 当 analyzeData 变化时，转换为 docData 格式
watch(() => props.analyzeData, (val) => {
  if (!val) return
  const isSecondTrial = val.trialLevel?.includes('二审')
  const raw = val.rawResult ? JSON.parse(val.rawResult) : {}
  const sections = []

  // 非二审：用一审字段（始终推入，不管是否为空）
  if (!isSecondTrial) {
    sections.push({ id: 'claims', title: '诉讼请求（原告诉请）', text: val.claims || '' })
    // sections.push({ id: 'defense', title: '辩称（被告答辩意见）', text: val.defense || '' })
    sections.push({ id: 'find', title: '认定事实', text: val.facts || '' })
    sections.push({ id: 'think', title: '本院认为', text: val.courtOpinion || '' })
    sections.push({ id: 'result', title: '判决结果', text: val.judgment || '' })
  } else {
    // 二审：按顺序展示一审字段 → 二审字段（始终推入）
    sections.push({ id: 'first-claims', title: '一审诉讼请求（原审原告的诉讼请求）', text: val.firstInstanceClaims || '' })
    // sections.push({ id: 'first-defense', title: '一审辩称（原审被告的答辩意见）', text: val.firstInstanceDefense || '' })
    sections.push({ id: 'first-find', title: '一审认定事实', text: val.firstInstanceFacts || '' })
    sections.push({ id: 'first-think', title: '一审本院认为', text: val.firstInstanceOpinion || '' })
    sections.push({ id: 'first-result', title: '一审判决结果', text: val.firstInstanceJudgment || '' })
    sections.push({ id: 'second-claims', title: '二审诉讼请求（上诉人的上诉请求）', text: val.secondInstanceClaims || '' })
    // sections.push({ id: 'second-defense', title: '二审辩称（被上诉人的答辩意见）', text: val.secondInstanceDefense || '' })
    sections.push({ id: 'second-find', title: '二审认定事实', text: val.secondInstanceFacts || '' })
    sections.push({ id: 'second-think', title: '二审本院认为', text: val.secondInstanceOpinion || '' })
    sections.push({ id: 'second-result', title: '二审判决结果', text: val.secondInstanceJudgment || '' })
  }

  docData.value = {
    caseNumber: val.caseNumber || raw['案号'] || '',
    title: `${raw['案号'] || val.caseNumber || ''} ${raw['案件类型'] || ''}`,
    // subInfo: `${val.caseNumber || ''} | ${val.court || ''} | ${raw['判决日期'] || ''}`,
    subInfo: ` ${val.court || ''} `,
    participants: val.participants || raw['诉讼参与人'] || '',
    trialInfo: val.trialInfo || raw['审理经过'] || '',
    // trialOrg: val.trialOrg || raw['审判组织'] || '',
    sections
  }
}, { immediate: true })
</script>
<style scoped lang="less">
.content-wrap {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 0 10px;
  background: #FFFFFF;
  box-shadow: 0px 10px 28px 0px rgba(35,66,112,0.06);
  border-radius: 14px 14px 14px 14px;
  border: 1px solid #DFE6F2;
  padding: 24px 12px;
}
.tab-list {
  position: sticky;
  top: -24px;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 24px 12px 12px;
  margin: -24px -12px 12px;
  background: #FFFFFF;
  .tab-item {
    padding: 6px 16px;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    background: #FFFFFF;
    box-shadow: 0px 10px 28px 0px rgba(35,66,112,0.06);
    border-radius: 9px 9px 9px 9px;
    border: 1px solid #DFE6F2;
    font-weight: 400;
    font-size: 16px;
    color: #65738B;
    line-height: 22px;  
    white-space: normal;
    word-break: break-word;
    &.active {
    background: #EDF4FF;
    box-shadow: 0px 10px 28px 0px rgba(35,66,112,0.06);
    border-radius: 9px 9px 9px 9px;
    border: 1px solid #CFE0FF;
    font-weight: 400;
    font-size: 16px;
    color: #1768FF;
    line-height: 22px;
    }
  }
}
.doc-card {
  background: #fff;
  border-radius: 14px;
  padding: 0 14vw;
  .doc-title {
    margin: 0; 
      /* 字体：小标宋体，无环境 fallback 可用 SimSun 宋体兜底 */
    font-family: "小标宋体", "SimSun", serif;
    /* 二号字 22pt ≈ 29px */
    font-size: 29px;
    /* 小标宋体标准加粗 */
    font-weight: bold;
    /* 公文标准行间距，二号字推荐 1.3~1.5 */
    line-height: 28.95pt;
    /* 文字常规黑色 */
    color: #000000;
    text-align: center;
  }
  .doc-sub {
    text-align: center;
    // font-size: 13px;
    // color: #86909C;
    margin: 0; 
      /* 字体：小标宋体，无环境 fallback 可用 SimSun 宋体兜底 */
    font-family: "小标宋体", "SimSun", serif;
    /* 二号字 22pt ≈ 29px */
    font-size: 29px;
    /* 小标宋体标准加粗 */
    font-weight: bold;
    /* 公文标准行间距，二号字推荐 1.3~1.5 */
    line-height: 50pt;
    /* 文字常规黑色 */
    color: #000000;
  }
  .brief-box {
    background: #FFF7E6;
    border-radius: 8px;
    padding: 14px;
    font-size: 14px;
    color: #AD6800;
    margin-bottom: 30px;
  }
  .section {
    margin-bottom: 26px;
    h3 {
      margin-bottom: 24px;
      margin: 0; 
      letter-spacing: 5.25px; 
      line-height: 32pt; 
      // text-align: center; 
      font-size: 21.3333px; 
      font-family: 黑体; 
      white-space: nowrap;
      display:flex; 
      // justify-content: center;
    }
    p {
      // font-size: 14px;
      // line-height: 26px;
      font-family: "仿宋_GB2312", SimSun, serif;
      font-size: 16pt;
      font-weight: 400;
      line-height: 28pt;
      color: #52627B;
      margin: 0;
      text-indent: 2em;
    }
  }
}
</style>
